import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 3C27.8366 3 35 10.1634 35 19C35 27.8366 27.8366 35 19 35C10.1634 35 3 27.8366 3 19C3 10.1634 10.1634 3 19 3ZM23 10C19.9624 10 17.5 12.4624 17.5 15.5C17.5 18.5376 19.9624 21 23 21C26.0376 21 28.5 18.5376 28.5 15.5C28.5 12.4624 26.0376 10 23 10Z",
		fill: "black"
	})
});
export default SvgIconLogo;
